
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"-g-Combined Shape","d":"M2.217 12.553a.825.825 0 010-1.114l7.457-7.986 1.1 1.114-6.19 6.633H20.4a1.6 1.6 0 011.6 1.6H4.581l6.193 6.633-1.1 1.113z","stroke":"#000","stroke-miterlimit":"10","stroke-width":".3"}})])
          )
        }
      }
    